<template>
  <b-nav-item-dropdown
    :text="currentLocale"
    dropup
  >
    <b-dropdown-item
      v-for="language in availableLocales"
      :key="language"
      @click="switchLocale(language)"
    >
      {{ language.toUpperCase() }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script setup lang="ts">
import { Ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStorage } from '@vueuse/core';
const { locale, availableLocales } = useI18n({ useScope: 'global' });

const currentLocale = computed(() =>
  localeInLocaleStorage.value?.toUpperCase()
);
const localeInLocaleStorage: Ref<string> = useStorage(
  'locale',
  localStorage.getItem('locale') as string
);

const switchLocale = (newLocale: string) => {
  if (newLocale && availableLocales.includes(newLocale)) {
    locale.value = newLocale;
    localeInLocaleStorage.value = newLocale.toLowerCase();
  } else {
    console.warn(
      `Tried to set locale to ${newLocale} which is not part of the available locales: ${availableLocales}.`
    );
  }
};
</script>
